<template>
    <div class="invite">
        <van-nav-bar title="排行" left-arrow @click-left="back"></van-nav-bar>

        <div class="invite-wrap">
            <div class="invite-subtitle">您已邀请{{ inviteCount }}人</div>
            <div class="invite-content">
                <div class="rank-title">邀请排行</div>
                <div class="invite-item__header">
                    <span class="rank-number">排名</span>
                    <span class="user-name">姓名</span>
                    <span class="user-count">人数</span>
                </div>
                <div class="invite-item" v-for="(item, index) in inviteList" :key="item.Id">
                    <span class="invite-index" :class="`rank${index}`">{{
            index + 1
          }}</span>
                    <span class="invite-item_name">{{ item.name }}</span>
                    <!-- <span class="invite-item_tel" v-if="item.tel">
            {{ item.tel.replace(/^(\d{3})\d{4}(\d{4})$/, "$1****$2") }}
          </span>-->
                    <span class="invite-item_count">{{ item.count }}人</span>
                </div>

                <div class="more" v-show="!inviteList.length">暂无邀请..</div>
            </div>

            <!-- <div class="tip" v-html="defaultInfo.config.hint"></div> -->
        </div>
    </div>
</template>

<script>
import vueQr from 'vue-qr';
import httpRequest from '@/module_visitor/api/http.js';

import { mapGetters } from 'vuex';
export default {
    data() {
        return {
            inviteCount: 0,
            inviteList: [],
            show: false,
        };
    },
    computed: {
        ...mapGetters(['defaultInfo']),
    },
    components: {
        vueQr,
    },
    methods: {
        back() {
            this.$router.go(-1);
        },

        /** 邀请 */

        getMyInviteCount() {
            httpRequest.get(`/api/visitor/inviteCount`).then(res => {
                this.inviteCount = res.data.data;
            });
        },
        getInvite() {
            httpRequest.get(`/api/visitor/getInvite`).then(res => {
                this.inviteList = res.data.data;
            });
        },

        OnGetMore() {
            this.show = true;
        },
    },
    created() {
        this.getInvite();
        this.getMyInviteCount();
    },
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/mixin.scss';

.invite {
    height: 100vh;
    background: #f8f8f8;
    overflow-y: auto;
    .invite-wrap {
        .invite-subtitle {
            text-align: center;
            border: 1px solid #eaeaea;
            background: #fff;
            padding: 10px;
            border-radius: 10px;
            margin: 20px;
        }
        .tip {
            padding: 10px;
            border-radius: 10px;
            margin: 20px;
            border: 1px solid #eaeaea;
            background: #fff;
        }
        .rank-title {
            text-align: center;
            padding: 4px 10px 20px;
            font-size: 18px;
        }
        .invite-content {
            background: #fff;
            margin: 10px 20px;
            padding: 20px;
            border-radius: 4px;
            .rank-title {
            }

            .invite-item__header {
                display: flex;
                color: #666;
                .rank-number {
                    width: 30%;
                }
                .user-name {
                    width: 50%;
                }
                .user-count {
                    width: 20%;
                }

                span {
                    font-size: 12px;
                }
            }
            .invite-item {
                display: flex;
                align-items: center;
                justify-content: space-around;
                height: 32px;
                padding: 8px;
                border-bottom: 1px solid #eaeaea;
                color: #666;
                font-size: 16px;
                .invite-index {
                    width: 30%;
                }

                .rank0 {
                    color: #ff737e;
                }
                .rank1 {
                    color: #a95158;
                }
                .rank2 {
                    color: #3f3f3f;
                }
                .invite-item_name {
                    font-size: 16px;
                    width: 50%;
                }

                .invite-item_tel {
                    color: #333;
                }

                .invite-item_count {
                    width: 20%;
                    color: #333;
                    font-size: 16px;
                }
            }

            .more {
                margin-top: 10px;
                text-align: center;
                color: #fff;
            }
        }
    }

    .activity {
        padding: 4px;
        color: #333;

        .activity-title {
            text-align: center;
            font-size: 18px;
            padding: 4px;
        }

        .activity-content {
            font-size: 14px;
            padding: 0 4px;

            p {
                padding: 2px 0;
            }

            p {
                span {
                }
            }

            p {
                span {
                }
            }

            p {
                span {
                }
            }

            p {
                span {
                }
            }
        }

        .activity-info {
            display: flex;
            justify-content: flex-end;
            padding: 0 4px;
            font-size: 14px;

            span {
            }
        }
    }

    .popup-title {
    }

    .popup-content {
        padding: 10px 20px;

        .popup-item {
            display: flex;
            justify-content: space-between;
            padding: 4px 0;

            .popup-item_sort {
                width: 4%;
            }

            .popup-item_name {
                width: 30%;
            }

            .popup-item_tel {
                width: 40%;
            }

            .popup-item_count {
                width: 20%;
                text-align: right;
            }
        }
    }
}
</style>